import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from '../components/AppNavbar.jsx';
import AppFooter from '../components/AppFooter.jsx';

/**
 * Shared application shell reused by every named layout. Translates the raw
 * design shells (RawHTMLDesign/layouts/*.html) — which are all the same
 * fixed-top navbar + main content region + footer chrome — into a single
 * React layout. Named layout components wrap this and add their identity marker.
 *
 * `children` renders when used directly; otherwise the router's <Outlet />
 * injects the matched page into the main content region.
 */
export default function AppLayout({ children }) {
  return (
    <div className="app-layout prospectus d-flex flex-column min-vh-100">
      <AppNavbar />
      {/* padding-top clears the fixed-top navbar (raw shell used 80px) */}
      <main className="flex-grow-1" style={{ paddingTop: '80px' }}>
        <div className="container-fluid py-4">{children || <Outlet />}</div>
      </main>
      <AppFooter />
    </div>
  );
}
